const filterRoomGroupForScreen = (data) => data.filter((el) => el.status === 'complete')

export default filterRoomGroupForScreen
